import styled from '@styled';
import { font_nunito, tabletPortrait } from '../global.styles';
import { css, keyframes } from 'styled-components';

interface StyledParagraphProps {
  fontSize?: string;
  color?: string;
  margin?: string;
  padding?: string;
  textAlign?: string;
  fontWeight?: string;
  maxWidth?: string;
  mobileFontSize?: string;
  mobileMargin?: string;
  lineHeight?: string;
  display?: string;
  fontFamily?: string;
  mobileMaxWidth?: string;
  fontStyle?: string;
  linkColor?: string;
  bounces?: boolean;
  textTransform?: string;
  textDecoration?: string;
  boldColor?: string;
}

const zoomIn = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

export const StyledParagraph = styled('p').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'fontSize',
      'textAlign',
      'fontWeight',
      'maxWidth',
      'mobileFontSize',
      'mobileMargin',
      'lineHeight',
      'fontFamily',
      'mobileMaxWidth',
      'fontStyle',
      'linkColor',
      'textTransform',
      'textDecoration',
      'position',
      'boldColor',
    ].includes(prop),
})<StyledParagraphProps>`
  ${({ bounces }) =>
    bounces
      ? css`
          animation: ${zoomIn} 1s forwards;
        `
      : ''}
  font-size: ${(props) => props.fontSize || '16px'};
  color: ${(props) => props.color || '#606E7B'};
  margin: ${(props) => props['data-margin'] || '0'};
  padding: ${(props) => props.padding || '0'};
  display: ${(props) => props.display || 'block'};
  text-align: ${(props) => props.textAlign || 'start'};
  font-weight: ${(props) => props.fontWeight || '500'};
  max-width: ${(props) => props.maxWidth || '100%'};
  line-height: ${(props) => props.lineHeight || '1.5'};
  font-family: ${(props) => props.fontFamily || font_nunito};
  font-style: ${(props) => props.fontStyle || 'normal'};
  width: ${(props) => props.width || undefined};
  text-transform: ${(props) => props.textTransform || 'none'};
  text-decoration: ${(props) => props.textDecoration || 'none'};
  position: ${(props) => props.position || null};

  a {
    color: ${(props) => props.linkColor || '#0000ee'};
  }

  strong {
    color: ${(props) => props.boldColor || props.color || '#606E7B'};
  }

  ${tabletPortrait} {
    font-size: ${(props) => props.mobileFontSize || props.fontSize || '16px'};
    margin: ${(props) => props.mobileMargin || props['data-margin'] || '0'};
    max-width: ${(props) => props.mobileMaxWidth || props.maxWidth || '100%'};
  }
`;
